export const guideSteps = [
  {
    id: "guide-1",
    step: "第一步",
    title: "先接受前期的搞笑基调",
    desc: "作品开头是一段以日常搞笑为主的篇幅。很多人在这里因为「不是想象中的热血番」而放弃，其实这一段正在悄悄铺人物关系。角色认全了，后面的战斗才有代入感。",
  },
  {
    id: "guide-2",
    step: "第二步",
    title: "认准主线真正开始的节点",
    desc: "当剧情进入第一个成体系的战斗篇章时，节奏会明显加快。如果你只想看主线，可以把日常篇当成人物介绍来快速浏览，而不必逐集细看。",
  },
  {
    id: "guide-3",
    step: "第三步",
    title: "留意角色之间的羁绊变化",
    desc: "这部作品真正的看点不是招式，而是关系的变化：谁信任谁、谁为谁改变。留意这些细节，比记住招式名称更能帮你理解结局为什么那样安排。",
  },
  {
    id: "guide-4",
    step: "第四步",
    title: "决定漫画还是动画",
    desc: "动画覆盖的篇幅有限，漫画则更完整。想省时间可以先看动画，想补完整剧情再回到漫画。两条路都可行，关键是弄清楚自己更在意体验还是完整性。",
  },
];

export const faqs = [
  {
    id: "faq-1",
    q: "《我的家庭教师》讲的是一个什么样的故事？",
    a: "它讲的是一个普通中学生被指定为黑手党家族继承人后，被迫成长的故事。表层是搞笑日常与热血战斗的结合，里层则是一个少年如何逐渐确认自己想要什么、愿意为谁而改变。",
  },
  {
    id: "faq-2",
    q: "里包恩到底是谁？他为什么是个婴儿？",
    a: "里包恩表面身份是纲吉的家庭教师，实际是顶尖杀手，同时也是彩虹之子之一。他之所以以婴儿形态存在，与彩虹之子所背负的诅咒有关，这条线索会在剧情后段得到较为集中的说明。",
  },
  {
    id: "faq-3",
    q: "结局是悲剧吗？会不会很难受？",
    a: "整体基调并不指向悲剧。作品在收尾时保留了开放与温暖的感觉，关于它算不算「圆满」，观众看法不一，这也是围绕结局讨论最多的地方。",
  },
  {
    id: "faq-4",
    q: "动画和漫画的剧情一样吗？",
    a: "不完全一样。电视动画播出至 2010 年，覆盖到彩虹之子相关的部分便告结束；漫画则继续向后推进，篇幅更完整。所以如果你只看了动画，会感觉故事停在一个相对中途的位置。",
  },
  {
    id: "faq-5",
    q: "从哪里开始看比较合适？",
    a: "最稳妥的方式是从头看起，把前期的日常当成人物介绍。如果你已经熟悉角色，也可以从第一个成规模的战斗篇章切入。不建议直接从结尾看起，那样会丢掉大量铺垫。",
  },
  {
    id: "faq-6",
    q: "这部作品最值得看的是什么？",
    a: "是角色成长与群像塑造。战斗设定固然有趣，但真正让人记住的是那些从逃避到承担、从互不信任到并肩作战的变化。理解了这一点，就理解了这部作品的核心。",
  },
];